import { Grid, Container } from '@mui/material';
import Footer from 'src/components/Footer';
import { useState, useEffect } from 'react';
import SnackbarAlert from '../common/SnackbarAlert';
import { checkPermission } from '../../utils/permission';
import NoPermissionContent from '../common/NoPermissionContent';
import Loader from '../common/Loader';
import PolicyLodList from './policyLodList';
import CreateEdit from './createEditPolicyLod';

function PolicyLod() {
  const [showCreateEdit, setShowCreateEdit] = useState(false);
  const [requirementEditDatas, setRequirementEditDatas] = useState(null);
  const [editStatus, setEditStatus] = useState(false);

  const [isLoading, setLoading] = useState(true);

  // ✅ Permission states
  const [lodViewPermission, setLodViewPermission] = useState(false);
  const [lodCreatePermission, setLodCreatePermission] = useState(false);
  const [lodUpdatePermission, setLodUpdatePermission] = useState(false);
  const [lodDeletePermission, setLodDeletePermission] = useState(false);

  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });

  const showCreateEditForm = () => {
    setShowCreateEdit(true);
  };

  const closeCreateEditForm = (status) => {
    setEditStatus(false);
    setRequirementEditDatas(null);
    setShowCreateEdit(false);
    if (status === true) {
      setShowSnackBarAlert({
        status: true,
        type: 'success',
        message: 'Requirement saved'
      });
    }
  };

  const editDatas = (editData) => {
    setEditStatus(true);
    setRequirementEditDatas(editData);
    setShowCreateEdit(true);
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  useEffect(() => {
    checkRolePermission();
  }, []);

  const checkRolePermission = async () => {
    try {
      const viewPermission = await checkPermission(
        'ListOfRequirements',
        'View'
      );
      setLodViewPermission(viewPermission);

      const createPermission = await checkPermission(
        'ListOfRequirements',
        'Create'
      );
      setLodCreatePermission(createPermission);

      const updatePermission = await checkPermission(
        'ListOfRequirements',
        'Update'
      );
      setLodUpdatePermission(updatePermission);

      const deletePermission = await checkPermission(
        'ListOfRequirements',
        'Delete'
      );
      setLodDeletePermission(deletePermission);

      setLoading(false);
    } catch (error) {
      console.error('Permission check failed:', error);
      setLoading(false);
    }
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />

      {isLoading ? (
        <Loader />
      ) : showCreateEdit && (lodCreatePermission || lodUpdatePermission) ? (
        <CreateEdit
          closeCreateEditForm={closeCreateEditForm}
          editData={requirementEditDatas}
        />
      ) : (
        <Container maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={3}
          >
            <Grid item xs={12} className="ListContainer">
              {lodViewPermission ? (
                <PolicyLodList
                  editDatas={editDatas}
                  showCreateEditForm={showCreateEditForm}
                />
              ) : (
                <NoPermissionContent />
              )}
            </Grid>
          </Grid>
        </Container>
      )}

      <Footer />
    </>
  );
}

export default PolicyLod;
